import { useCallback, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { HowItWorks } from "@/components/admin/HowItWorks";
import AdminShell from "@/components/admin/AdminShell";
import { Controls } from "@/components/vi/Controls";
import { Acquisition, Overview, Realtime } from "@/components/vi/Core";
import { Geography } from "@/components/vi/Geography";
import { Campaigns } from "@/components/vi/Campaigns";
import { Funnels, Pages, Tech } from "@/components/vi/Journeys";
import { Referrals, Registrations, Retention, Revenue } from "@/components/vi/Business";
import { Alerts, Ask, Events, Reports } from "@/components/vi/Explore";
import { Privacy, Tracking } from "@/components/vi/Admin";
import { ViCtx } from "@/lib/vi";
import { cn } from "@/lib/utils";

const SECTIONS = [["overview", "Executive Overview", Overview], ["realtime", "Real-Time", Realtime], ["acquisition", "Acquisition", Acquisition], ["campaigns", "Campaigns & Email", Campaigns], ["geography", "Geography", Geography], ["tech", "Devices & Tech", Tech], ["pages", "Pages & Journeys", Pages], ["funnels", "Funnels", Funnels], ["registrations", "Registrations", Registrations], ["revenue", "Revenue", Revenue], ["retention", "Retention", Retention], ["referrals", "Referrals", Referrals], ["events", "Event Explorer", Events], ["ask", "AI Assistant", Ask], ["alerts", "Alerts", Alerts], ["reports", "Custom Reports", Reports], ["tracking", "Tracking Setup", Tracking], ["privacy", "Privacy", Privacy]];

export default function VisitorIntel() {
  const { section = "overview" } = useParams();
  const [s, setS] = useState({ preset: "30d", start: "", end: "", compare: "previous", filters: {}, bots: false });
  const set = useCallback((p) => setS((x) => ({ ...x, ...p })), []);
  const setFilter = useCallback((k, v) => setS((x) => { const f = { ...x.filters }; if (v == null || v === "") delete f[k]; else f[k] = String(v); return { ...x, filters: f }; }), []);
  const [, label, View] = SECTIONS.find(([k]) => k === section) || SECTIONS[0];
  return (
    <AdminShell title="Visitor Intelligence" subtitle="First-party analytics: who visits, where they come from, and what turns them into customers.">
      <ViCtx.Provider value={{ s, set, setFilter }}>
        <div className="grid gap-5 lg:grid-cols-[210px_1fr]" data-testid="vi-page">
          <nav className="flex gap-1 overflow-x-auto pb-1 lg:flex-col lg:overflow-visible" data-testid="vi-nav">{SECTIONS.map(([k, l]) => <NavLink key={k} to={`/admin/vi/${k}`} className={() => cn("whitespace-nowrap rounded-lg px-3 py-2 text-sm transition-colors", section === k ? "bg-[#D4AF37]/15 text-[#F3C649]" : "text-zinc-400 hover:bg-[#121215] hover:text-zinc-100")} data-testid={`vi-nav-${k}`}>{l}</NavLink>)}</nav>
          <div className="min-w-0 space-y-4">
            <h2 className="font-display text-2xl text-zinc-50" data-testid="vi-title">{label}</h2>
            {section === "overview" && <HowItWorks id="vi" />}
            {!["tracking", "privacy", "realtime"].includes(section) && <Controls />}
            <View key={section} />
          </div>
        </div>
      </ViCtx.Provider>
    </AdminShell>
  );
}
